// ale-animate.js — Maison Nagi animations
// Plain vanilla JS, no build step required

document.addEventListener('DOMContentLoaded', function () {

  // ─────────────────────────────────────────────
  // 1. ONE-WAY ANIMATION
  //    Element animates in once when it enters view.
  //    Does NOT re-animate on scroll up/down.
  //    Once visible, stays visible forever.
  // ─────────────────────────────────────────────

  // For hero elements (above fold), show immediately
  document.querySelectorAll('[data-ale-anim]').forEach(function (el) {
    var rect = el.getBoundingClientRect();
    if (rect.top < window.innerHeight * 0.85) {
      el.classList.add('ale-visible');
    }
  });

  // One-way IntersectionObserver — add ale-visible once, then stop observing
  var oneWayObs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('ale-visible');
        // Unobserve so it never removes the class again
        oneWayObs.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.15,
    rootMargin: '0px 0px -8% 0px'
  });

  document.querySelectorAll('[data-ale-anim]').forEach(function (el) {
    if (!el.classList.contains('ale-visible')) {
      oneWayObs.observe(el);
    }
  });

  // ─────────────────────────────────────────────
  // 2. SCIENCE TABS  .ale-science__tab
  // ─────────────────────────────────────────────
  document.querySelectorAll('.ale-science__tabs').forEach(function (tabBar) {
    tabBar.querySelectorAll('.ale-science__tab').forEach(function (tab) {
      tab.addEventListener('click', function () {
        var idx = tab.dataset.tab;
        var sec = tab.closest('.ale-science');
        if (!sec) return;
        sec.querySelectorAll('.ale-science__tab').forEach(function (t) { t.classList.remove('ale-active'); });
        sec.querySelectorAll('.ale-science__panel').forEach(function (p) { p.classList.remove('ale-active'); });
        tab.classList.add('ale-active');
        var panel = sec.querySelector('.ale-science__panel[data-panel="' + idx + '"]');
        if (panel) panel.classList.add('ale-active');
      });
    });
  });

});
